class ScrollAnimation
{
	static init()
	{
		const observer = new IntersectionObserver((entries) => {

			entries.forEach(entry => {

				if(entry.isIntersecting)
				{
					entry.target.classList.add("inview");
				} else {
					entry.target.classList.remove("inview");
				}

			})

		}, {
			threshold: 0.2
		})

		document.querySelectorAll('[class*="inview"]').forEach(el => {
			observer.observe(el);
		});


	}
}

export default ScrollAnimation;
